import React from "react";
import {
    Modal,
    message,
    Upload,
    Form,
    Icon,
    InputNumber,
    Select,
    Popconfirm,
    Button,
} from "antd";
import _ from "lodash";
import Services from "../../../services/categories";
import ItemFormHelper from "./../itemForm/ItemFormHelper";

// select-option
const Option = Select.Option;

//   upload-script start
const props = {
    name: "file",
    action: "//jsonplaceholder.typicode.com/posts/",
    headers: {
        authorization: "authorization-text",
    },
    onChange(info) {
        if (info.file.status !== "uploading") {
        }
        if (info.file.status === "done") {
            message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === "error") {
            message.error(`${info.file.name} file upload failed.`);
        }
    },
};
//   upload-script end
let PreviewFromLink = {
    _id: "",
    uid: "",
    name: "",
    status: "done",
    response: "ok",
    url: "",
};

class AdsSection extends React.Component {
    // form-scripts start
    handleFormLayoutChange = (e) => {
        this.setState({ formLayout: e.target.value });
    };

    constructor() {
        super();
        this.state = {
            formLayout: "horizontal",
            previewVisible: false,
            addOption: false,
            visible: false,
            addItem: false,
            previewImage: "",
            ad: { sortNo: [], fields: [], fileName: [], originalName: [] },
            fileList: [],
            imageFiles: [],
            filteredInfo: null,
            sortedInfo: null,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { editFormContents } = this.props;
        if (!_.isEqual(prevProps.editFormContents, editFormContents)) {
            if (editFormContents?.length) {
                const sortNo = [], fields = [], fileList = [], fileName = [], originalName = [];

                const formattedAdData = editFormContents?.map((ad) => {
                    if (ad?.type == "ads") {
                        fileName.push(ad?.ads?.fileName);
                        originalName.push(ad?.ads?.originalName);
                        sortNo.push(ad?.sort);
                        fields.push("");
                        fileList.push([
                            {
                                ...PreviewFromLink,
                                // _id: ad?._id,
                                uid: ad?.ads.fileName,
                                originalName: ad?.ads.originalName,
                                // name: ad?.name,
                                url: `/api/util/image?key=${ad?.ads.fileName}`,
                            },
                        ]);
                    }
                });

                this.setState({
                    ad: { sortNo, fields, fileName, originalName },
                    fileList
                });
            }
        }
    }
    // Modal-scripts start
    showModal = () => {
        this.setState({
            visible: true,
        });
    };
    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    };
    addItem = (e) => {
        this.setState({
            addItem: !this.state.addItem,
        });
    };
    addOption = (e) => {
        this.setState({
            addOption: !this.state.addOption,
        });
    };
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    };
    // Modal-scripts end

    // pictureUpload scripts start

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    };
    handleRemove = (file, i) => {
        this.setState((prev) => {
            if (
                JSON.stringify(prev.imageFiles[i]?.uid) === JSON.stringify(file?.uid)
            ) {
                // prev.imageFiles.splice(i, 1);
                prev.imageFiles[i] = null;
            }
            delete prev.fileList[i];
            return { ...prev };
        });
    };
    handleUploadBegin = (file, i) => {
        this.setState((prev) => {
            prev.imageFiles[i] = file;
            return {
                imageFiles: prev.imageFiles,
            };
        });
    };
    handleChange = (e, index) => {
        this.setState((prev) => {
            prev.fileList[index] = e.fileList;
            return { fileList: prev.fileList };
        });
    };

    customRequest = ({ file, onSuccess }) => {
        if (file.status !== "uploading") {
        }
        if (file.status === "done") {
            message.success(`${file.name} file uploaded successfully`);
        } else if (file.status === "error") {
            message.error(`${file.name} file upload failed.`);
        }
        setTimeout(() => onSuccess("ok"), 0);
    };
    // pictureUpload scripts End
    columnGenerator = (id) => {
        return (
            <React.Fragment>
                <div className="ant-row" key={id}>
                    <div className="ant-col-md-12">
                        <InputNumber placeholder="Add sortNo" />
                    </div>
                </div>
                <br />
            </React.Fragment>
        );
    };

    _renderAd = (i) => {
        const addSortNo = (value) => {
            // e.persist();
            this.setState((prev) => {
                prev.ad.sortNo[i] = value;
                return {
                    ad: prev.ad,
                };
            });
        };

        const { previewVisible, previewImage, fileList } = this.state;
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
            </div>
        );
        return (
            <div className="ant-row" key={"Ad_" + i}>
                <div className="ant-col-md-8">
                    <InputNumber
                        required
                        // type="text"
                        placeholder="Sort No"
                        onChange={addSortNo.bind(this)}
                        value={this.state.ad.sortNo[i]}
                    />
                </div>

                <div className="ant-col-md-4 upload-img-main">
                    <Upload
                        listType="picture-card"
                        fileList={fileList[i]}
                        onPreview={this.handlePreview}
                        customRequest={this.customRequest}
                        beforeUpload={(file) => this.handleUploadBegin(file, i)}
                        onChange={(e) => this.handleChange(e, i)}
                        onRemove={(file) => this.handleRemove(file, i)}
                        accept="image/jpeg, image/png"
                    >
                        {fileList[i]?.length ? null : uploadButton}
                    </Upload>
                    <Modal
                        visible={previewVisible}
                        footer={null}
                        onCancel={this.handleCancel}
                    >
                        <img alt="example" style={{ width: "100%" }} src={previewImage} />
                    </Modal>
                </div>
                <div className="ant-col-md-4 rite-btn">
                    <div className="action-btn">
                        <a href="" title="Delete">
                            <Popconfirm
                                title="Are you sure delete this ?"
                                onConfirm={() => {
                                    this.setState((prev) => {
                                        // Services.removeBanner(this.state.ad._id[i])
                                        delete prev.ad?.fields[i];
                                        delete prev.fileList[i];
                                        return { ad: prev.ad, fileList: prev.fileList };
                                    });
                                }}
                                onCancel={() => { }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <span className="gx-link" title="Delete">
                                    <i class="icon icon-trash"></i>
                                </span>
                            </Popconfirm>
                        </a>
                    </div>
                </div>
            </div>
        );
    };
    render() {
        const { formLayout } = this.state;

        // MULTIPLE-scripts start
        const children = [];
        for (let i = 1; i < 10; i++) {
            children.push(<Option key={i.toString(36) + i}>{"test"}</Option>);
        }

        // MULTIPLE-scripts End

        // Sort-Table-Scripts-Start
        let { sortedInfo, filteredInfo } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};

        // sort-table-scripts-End

        // AdState Setter Start
        ItemFormHelper.setAdsState({
            ad: this.state.ad,
            images: this.state.imageFiles,
        });
        // AdState Setter End

        return (
            <Form>
                <div className="ant-row hd-title gx-m-0">
                    <div className="ant-col-md-12">
                        <h1>Manage Ads</h1>
                    </div>
                    <div className="ant-col-md-12 rite-btn">
                        <Button
                            type="primary"
                            className="color-white"
                            onClick={() => {
                                this.setState((prev) => {
                                    prev.ad.fields.push("");
                                    return { ad: prev.ad };
                                });
                            }}
                        >
                            <i class="icon icon-add"></i> Add
            </Button>
                    </div>
                </div>

                <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                        <div className="item-detail-edit-box">
                            {this.state.ad?.fields?.map((item, index) => {
                                return this._renderAd(index);
                            })}
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

export default AdsSection;